import Cookies from 'js-cookie';

function ReceiptController($scope,$http, $rootScope, $routeParams, RecieptSvc, CartSvc, MyTicketsMonthYearSvc) {
  'ngInject';

  //Set the receipt object
  $scope.Receipt = {};
  //Re-Set the cart items
  $rootScope.CartItems_Count = 0;
  $rootScope.CartItems_Total = 0;
  $scope.charityEnabled = false;

  Cookies.remove('TLF_ItemsInCart'); // remove cookie so they don't get a reminder the next time they log in

  jQuery(document).ready(function ($) {
    MyTicketsMonthYearSvc.get({ APIKey: Cookies.get('TLF_Auth_Token'), Year: $scope.CurrentYear, Month: $scope.CurrentMonth }, function (data) {
      $rootScope.TicketCount = data;
    });
    RecieptSvc.get({ APIKey: Cookies.get('TLF_Auth_Token'), CartTransactionId: $routeParams.CartTransactionId }, function (data) {
      $scope.Receipt = data;
      if(data.Charity.Name != ""){
        $scope.charityEnabled = true
        $scope.Receipt.Organization.Url = data.Charity.Url
      }
      if(data.Affiliate.Name != ""){
        $scope.Receipt.Organization.Url = data.Affiliate.Url
      }

      //Because the Receipt can wait until the tickets are issued we need to update the cart again.
      CartSvc.get({ APIKey: Cookies.get('TLF_Auth_Token') }, function (data) {
        $rootScope.CartItems_Count = data.length;
      });
    });
  });

    $scope.resentRecepit = function () {
        jQuery(document).ready(function ($) {
            $('#modal').show();
            $('#resend-receipt-start').fadeIn(500);
        });
        
        $http.get(TFL_Base_Url + 'purchase/receipt/resend?CartTransactionId=' + $routeParams.CartTransactionId)
        .then(function (response) {

            jQuery(document).ready(function ($) {
                $('#modal').fadeIn(500, function () {
                    $('#resend-receipt-start').hide();
                    $('#resend-receipt-end').show();
                });
            });
        });
    }
};

export default {
    name: 'receiptController',
    fn: ReceiptController
}